import { shallowMount } from "@vue/test-utils";
import Container from "@/components/core/Container";

describe("Container component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(Container);
  });

  it("Renders del component Container", () => {
    expect(wrapper).toBeDefined();
  });
});
